import React from "react";
import SubscriptionRadio from "components/sell/SubscriptionRadio";

export default function PlanChooser(props) {
  const {
    radioOnChange,
    subscriptionType,
    annualRadioProps,
    monthlyRadioProps,
    annualOverMonthlySavings,
    groupsInfoPath
  } = props;

  return (
    <div className="plan-chooser">
      <form
        id="renewal-form"
        className="js-renewal-form lc-form signup-subscribe-form lc-stripe-card-inputs-ready"
      >
        <h3 className="choose-your-plan">1. Subscription Plan</h3>
        <div className="plans lc-field" id="plan-chooser">
          <SubscriptionRadio
            onChange={radioOnChange}
            checked={subscriptionType === annualRadioProps.value}
            {...annualRadioProps}
          />
          <SubscriptionRadio
            onChange={radioOnChange}
            checked={subscriptionType === monthlyRadioProps.value}
            {...monthlyRadioProps}
          />
          <p className="promo">
            Save {annualOverMonthlySavings} USD per year if you choose the
            annual subscription!
          </p>
        </div>
        <p className="stripe-updates-groups-info subtitle-1">
          Interested in a group discount?{" "}
          <a href={groupsInfoPath}>Learn more</a>
        </p>
      </form>
    </div>
  );
}
